import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
// import GameScreen from './features/game/GameScreen'
import OAuthCallbackScreen from './features/oauth/OAuthCallbackScreen'
import ApprovalCallbackScreen from './features/approval/ApprovalCallbackScreen'

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path='/oauth/callback' element={<OAuthCallbackScreen />} />
                <Route path='/approve-callback' element={<ApprovalCallbackScreen />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('unity-canvas')
)
// <Route path='/' element={<GameScreen />} />
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
